// extracted by mini-css-extract-plugin
export var logoBox = "logo-module--logo-box--2963f";
export var logoDesktop = "logo-module--logo-desktop--24ced";
export var logoMobile = "logo-module--logo-mobile--aa99d";